import React, { useState } from "react";

import { saveProductCategory } from "@admin/domain/productCategories/api";
import Editor from "@admin/components/Editor";
import Input from "@admin/components/Input";
import CheckBox from "@admin/components/CheckBox";
import MultiLanguages from "@admin/components/MultiLanguage";
import Text from "./Text";
import PageSeoParamsEditor from "@admin/components/PageSeoParamsEditor";
import ImageInput from "@admin/components/ImageInput";
import ActiveComponentsForSpecialCategory from "./ActiveComponentsForSpecialCategory";
import AdditionalProducts from "./AdditionalProducts";

const LIST_URL = `/admin/product_categories` as const;

export default function ProductCategoryEditor() {
    const productCategory = window.CMS.productCategory || null;

    const [isSpecial, setIsSpecial] = useState<boolean>(
        productCategory?.is_special || false,
    );

    async function execute(body: FormData) {
        await saveProductCategory(productCategory, body);
    }

    return (
        <Editor
            backUrl={`${LIST_URL}/${productCategory?.id || ``}`}
            onSubmit={execute}
        >
            <CheckBox
                label="Активная категория"
                name="is_active"
                defaultChecked={productCategory?.is_active}
            />

            <Input
                label="Указание родительской категории"
                name="parent_accounting_id"
                placeholder="Uuid родительской категории"
                defaultValue={productCategory?.parent?.accounting_id}
            />

            <MultiLanguages
                languageElement={(language) => (
                    <Text language={language} texts={productCategory?.texts} />
                )}
            />

            <Input
                label="Uuid категории в 1С"
                name="accounting_id"
                defaultValue={productCategory?.accounting_id}
            />

            <CheckBox
                label="В меню каталога товаров"
                name="is_listed"
                defaultChecked={
                    productCategory?.is_listed !== undefined
                        ? productCategory?.is_listed
                        : true
                }
            />

            {productCategory?.parent?.accounting_id ===
                `ae5d7835-3d9a-11ea-818c-d89d676ef1eb` && (
                <CheckBox
                    label='В фильтре категорий каталога товаров (в шапке). Применимо для категорий "Для фильтра"'
                    name="in_filter_catalog"
                    defaultChecked={productCategory?.in_filter_catalog}
                />
            )}

            <Input
                label="Порядок отображения"
                type="number"
                name="order"
                defaultValue={productCategory?.order}
            />

            <ImageInput
                label="Иконка"
                name="picture_id"
                defaultValue={productCategory?.picture}
                thumbnailWidth={100}
                thumbnailHeight={100}
            />

            <ImageInput
                label="Иконка для МП"
                name="for_mobile_app_picture_id"
                defaultValue={productCategory?.forMobileAppPicture}
                thumbnailWidth={100}
                thumbnailHeight={100}
            />

            <ImageInput
                label="Картинка (баннер)"
                name="banner_id"
                defaultValue={productCategory?.banner}
                thumbnailWidth={100}
                thumbnailHeight={100}
            />

            <CheckBox
                label="Особая категория с активными компонентами"
                name="is_special"
                checked={isSpecial}
                onChange={(event) => setIsSpecial(event.target.checked)}
            />

            <CheckBox
                label="Новое оформление: подкатегории как фильтры товаров"
                name="has_product_filters"
                defaultChecked={productCategory?.has_product_filters}
            />

            {isSpecial ? (
                <ActiveComponentsForSpecialCategory
                    productCategory={productCategory}
                />
            ) : (
                <AdditionalProducts productCategory={productCategory} />
            )}

            <PageSeoParamsEditor />
        </Editor>
    );
}
